export interface OpenChatParams {
  contactId?: string;
  contactName?: string;
  contactType?: 'person' | 'company';
  contactUuid?: string;
}

const EVENT = 'chat:open'

export function openChat(params: OpenChatParams = {}): void {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: params }))
}

export function onOpenChat(handler: (p: OpenChatParams) => void): () => void {
  const listener = (e: Event) => handler((e as CustomEvent).detail || {})
  window.addEventListener(EVENT, listener)
  return () => window.removeEventListener(EVENT, listener)
}
